// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__jh-K8","info":"Note_info__1L38D","note":"Note_note__3oBRW","actions":"Note_actions__2Zu2U"};